import {
    ArrowLeftIcon,
    CalendarDaysIcon,
    ClockIcon,
    EnvelopeIcon,
} from "@heroicons/react/24/outline";

export const bookingUrl =
    "https://script.google.com/macros/s/AKfycbzp9aErjksyCTpuCZEhYnQPgoMiioDkG9MgRtlw8IOltbBx3mw4MDFp9oz2FONNNY8C/exec";

export default function ConsultationBooking() {
    return (
        <main className="relative min-h-screen overflow-hidden bg-slate-50 px-4 py-6 sm:px-6 sm:py-10">
            <div className="pointer-events-none absolute -left-32 -top-32 h-80 w-80 rounded-full bg-violet-100 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-32 -right-24 h-96 w-96 rounded-full bg-emerald-100 blur-3xl" />

            <div className="relative mx-auto max-w-6xl">
                <a
                    href="/?page=application"
                    className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-slate-700 shadow-sm ring-1 ring-slate-200 transition hover:-translate-x-1 hover:text-violet-700"
                >
                    <ArrowLeftIcon className="h-4 w-4" />
                    Վերադառնալ բաժիններին
                </a>

                <section className="mt-8 overflow-hidden rounded-[2rem] border border-violet-100 bg-white shadow-xl shadow-violet-100/60 sm:mt-10">
                    <div className="grid gap-8 bg-gradient-to-br from-violet-700 via-violet-600 to-emerald-600 px-6 py-9 text-white sm:px-10 lg:grid-cols-[1fr_auto] lg:items-end lg:px-12">
                        <div>
                            <span className="inline-flex rounded-full bg-white/15 px-4 py-2 text-sm font-bold ring-1 ring-white/25">
                                Առցանց ամրագրում
                            </span>
                            <h1 className="mt-5 max-w-3xl text-3xl font-bold tracking-tight sm:text-5xl">
                                Խորհրդատվություն
                            </h1>
                            <p className="mt-4 max-w-2xl text-base leading-7 text-violet-50 sm:text-lg">
                                Բոլոր ժամերը ցուցադրվում են։ Ազատ ժամերը կանաչ են, զբաղված ժամերը՝ կարմիր։
                            </p>
                        </div>

                        <div className="grid gap-3 text-sm font-semibold sm:grid-cols-3 lg:grid-cols-1">
                            <div className="flex items-center gap-3 rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
                                <ClockIcon className="h-5 w-5" />
                                1 ժամ
                            </div>
                            <div className="flex items-center gap-3 rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
                                <CalendarDaysIcon className="h-5 w-5" />
                                Ամեն օր՝ 10:00–18:00
                            </div>
                            <div className="flex items-center gap-3 rounded-2xl bg-white/15 px-4 py-3 ring-1 ring-white/20">
                                <EnvelopeIcon className="h-5 w-5" />
                                Հաստատում՝ էլ․ փոստով
                            </div>
                        </div>
                    </div>

                    <div className="p-2 sm:p-5 lg:p-7">
                        <iframe
                            src={bookingUrl}
                            title="Խորհրդատվության ամրագրման օրացույց"
                            className="h-[860px] w-full rounded-2xl border-0 bg-white sm:h-[900px]"
                            loading="eager"
                            credentialless=""
                        />

                        <p className="px-4 pb-4 text-center text-sm text-slate-500">
                            Եթե օրացույցը չի բացվում, օգտագործեք{" "}
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="font-bold text-violet-700 underline underline-offset-4"
                            >
                                ամրագրման ուղիղ հղումը
                            </a>
                            ։
                        </p>
                    </div>
                </section>
            </div>
        </main>
    );
}
